export const LOGO_URL = "/splash-logo.webp";
